import { createContext, useContext } from "react"

export interface ConfirmationOverlayFormContextValue {
  isSubmitDisabled: boolean
  isSubmitting: boolean
}

export const ConfirmationOverlayFormContext =
  createContext<ConfirmationOverlayFormContextValue>({
    isSubmitDisabled: false,
    isSubmitting: false
  })

export function useConfirmationOverlayFormContext() {
  return useContext(ConfirmationOverlayFormContext)
}
